import type { Meta, StoryObj } from '@storybook/web-components';
import { styleSample } from './pn-chat-stories-constants'
import { createDocumentation, createComponent } from '@/globals/documentation/story';
import docs from './pn-chat-docs.json';

const { argTypes, textContent } = createDocumentation(docs);

const meta: Meta<HTMLPnChatElement> = {
  title: 'Components/Widgets/Chat',
  parameters: {
    actions: {},
    docs: {
      description: {
        story: textContent,
      },
    },
  },
  args: {
    endpoint: 'https://localhost:51547/chat',
    language: 'sv',
    customerSegment: 'Private',
    mainHeading: 'PostNord Chat',
    sendButtonText: 'Send',
    relatedContentAriaLabel: 'Related',
    chatMinimizedAriaLabel: 'Chat minimized',
    chatOpenedAriaLabel: 'Chat opened',
    minimizeChatAriaLabel: 'Minimize chat',
    openChatAriaLabel: 'Open chat',
    chatControlsAriaLabel: 'Navigation controls',
    writeChatMessagePlaceholder: 'Write chat message',
    chatMessagesAriaLabel: 'Chat messages',
    sentMessageAriaLabel: 'Message sent',
    waitingForAnswerLabel: 'Waiting for answer',
    carouselSlidesToShow: 1.5,
    loadingText: 'Loading chat',
    messages: "",
    closeChatAriaLabel: "Close chat",
  },
  argTypes,
};

type Story = StoryObj<HTMLPnChatElement>;

export default meta;

export const Chat: Story = {
  name: 'Chat - Private',
  render: args => {
    const component = createComponent('pn-chat', args);
    return component;
  },
};

export const ChatBusiness: Story = {
  name: 'Chat - Business',
  render: args => {
    const component = createComponent('pn-chat', args);
    const customStyle = document.createElement('style');
    customStyle.innerHTML = styleSample;
    component.prepend(customStyle);
    return component;
  },
  args: {
    customerSegment: 'Business',
    messages: ""
  },
};

export const ChatRealSFIntegration: Story = {
  name: 'Chat - Real SF - integration',
  render: args => {
    const component = createComponent('pn-chat', args);
    const customStyle = document.createElement('style');
    customStyle.innerHTML = styleSample;
    component.prepend(customStyle);
    return component;
  }, args: {
    endpoint: 'https://se-inte.postnord.com/',
    customerSegment: 'Private',
    mainHeading: 'PostNord Chat real SF',
    sendButtonText: 'Send',
    relatedContentAriaLabel: 'Related',
    chatMinimizedAriaLabel: 'Chat minimized',
    chatOpenedAriaLabel: 'Chat opened',
    minimizeChatAriaLabel: 'Minimize chat',
    openChatAriaLabel: 'Open chat',
    chatControlsAriaLabel: 'Navigation controls',
    writeChatMessagePlaceholder: 'Write chat message',
    chatMessagesAriaLabel: 'Chat messages',
    sentMessageAriaLabel: 'Message sent',
    waitingForAnswerLabel: 'Waiting for answer',
    carouselSlidesToShow: 1.5,
    loadingText: 'Loading chat',
    messages: ""
  },
};

export const ChatNoFakeResponse: Story = {
  name: 'Chat - super Empty, loading icon',
  render: args => {
    const component = createComponent('pn-chat', args);
    const customStyle = document.createElement('style');
    customStyle.innerHTML = styleSample;
    component.prepend(customStyle);
    return component;
  },
  args: {
    messages: '',
    endpoint: 'https://localhost:51547/',
    customerSegment: 'Private',
    mainHeading: 'PostNord Chat Loading icon',
    sendButtonText: 'Send',
    relatedContentAriaLabel: 'Related',
    chatMinimizedAriaLabel: 'Chat minimized',
    chatOpenedAriaLabel: 'Chat opened',
    minimizeChatAriaLabel: 'Minimize chat',
    openChatAriaLabel: 'Open chat',
    chatControlsAriaLabel: 'Navigation controls',
    writeChatMessagePlaceholder: 'Write chat message',
    chatMessagesAriaLabel: 'Chat messages',
    sentMessageAriaLabel: 'Message sent',
    waitingForAnswerLabel: 'Waiting for answer',
    loadingText: 'Loading chat',
  },
};

export const ChatExamples: Story = {
  name: 'Chat - Examples from docs',
    render: args => {
    const component = createComponent('pn-chat', args);
    return component;
  },
  args: {
    messages: `{
  "header": {
    "body": null,
    "button": null
  },
  "messages": [
    {
      "category": "System",
      "content": "A customer service agent has entered the chat.",
      "messageId": "14584740-7784-4749-9b39-bce31455ea55"
    },
    {
      "category": "Bot",
      "content": "Varmt välkommen till PostNords virtuella assistent. Jag kan hjälpa dig med frågor gällande brev och paket samt skicka dig vidare till vår kundservice.",
      "messageId": "967ddba6-ba1c-44d1-9725-386b32dc3498"
    },
    {
      "category": "Bot",
      "content": "Hur kan jag hjälpa dig?",
      "messageId": "b26624af-852b-49cf-a3e6-77cc046be71f"
    },
    {
      "class": null,
      "category": "User",
      "content": "hejsan vart är mitt paket?",
      "messageId": "74cadc59-86ad-4f11-b4b6-a263aa9dbad9"
    },
    {
      "category": "Bot",
      "content": "Om du har ett kollinummer som berör din fråga, skriv gärna det här.",
      "messageId": "90845d71-2a8e-4b1a-bd45-20de7a2dbe5f"
    }
  ]
};`,
  },
}